import { isScheduleDefinitionSchedulingStrategyModel, type ScheduleDefinitionSchedulingStrategyModel, type SchedulingStrategyEditorProps } from '@/lib/action-modules/registry/scheduling/types'
import ScheduleDefinitionEditor from '../schedule-definition/ScheduleDefinitionEditor'
import { useTranslation } from 'react-i18next'

export default function ScheduleDefinitionStrategyEditor(props: SchedulingStrategyEditorProps) {
  const { t } = useTranslation('action-modules-wizard')
  const value = props.value
  if (!isScheduleDefinitionSchedulingStrategyModel(value)) return <>{t('editor.invalidValue')}</>

  return (
    <div className="flex flex-col gap-3">
      {/* The strategy description is rendered centrally by SchedulingStrategyTab. */}
      <ScheduleDefinitionEditor
        scheduleDefinition={value.scheduleDefinition}
        onUpdateScheduleDefinition={v => props.onChanged({
          ...value,
          scheduleDefinition: v
        } as ScheduleDefinitionSchedulingStrategyModel)}
        disabled={props.disabled}
      />
    </div>
  )
}
